import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=6744fe7e&scoped=true&"
import script from "./paymentPage.vue?vue&type=script&lang=js&"
export * from "./paymentPage.vue?vue&type=script&lang=js&"
import style0 from "./paymentPage.vue?vue&type=style&index=0&id=6744fe7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744fe7e",
  null
  
)

export default component.exports